import { State } from "country-state-city"

interface StateOptions {
  label: string
  value: string
}

/**
 * Returns a list of states for a given country code as options for a select field, where
 * the label is the state name and the value is the state iso code.
 *
 * @example
 * import { getStateOptions } from "@/nzds/utils/getStateOptions"
 * const stateOptions = getStateOptions('US')
 *
 */
export const getStateOptions = (countryCode?: string): StateOptions[] => {
  if (!countryCode) {
    return []
  }
  const states = State.getStatesOfCountry(countryCode).map(
    ({ name, isoCode }) => ({
      label: name,
      value: isoCode,
    })
  )
  const countryIsUSOrCA = ["US", "CA"].includes(countryCode)
  // Filters out minor territories which conveniently have an ISO code of 3 or more characters.
  if (countryIsUSOrCA) {
    return states.filter(({ value }) => value.length === 2)
  }
  return states
}
